<template>
  <el-select v-model="value" @change="change"
             filterable
             clearable
             :loading="loading"
             :remote-method="getMonitorName"
              placeholder="请选择监测链接">
    <el-option v-for="item in monitorNameOptions" :key="item.monitorId" :label="item.monitorName"
               :value="item.monitorId" />
  </el-select>
</template>

<script>

import {getMonitorName} from "@/api/manage/link/link";

export default {
  props: {
    modelValue: [String, Number],
    channelId: {
      type: [Number],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      monitorNameOptions: [],
      value: undefined,
      loading: false
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        if (this.value === newVal) return
        this.value = newVal
      },
      immediate: true // 立即执行回调函数
    },
    channelId: {
      handler() {
        this.getMonitorName()
      },
      immediate: true
    }
  },
  created() {
    this.getMonitorName()
  },
  methods: {
    getMonitorName () {
      this.loading = true
      getMonitorName({ channelId: this.channelId }).then(res => {
        if (res.code === 200) {
          this.monitorNameOptions = res.data
          this.value = ''
        }
      })
      this.loading = false
    },
    change (item) {
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    }
  }
}
</script>

<style scoped>

</style>
